import {
  Box,
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { AppBar, PageTitle, useLanguageTranslator } from "../../components";
import { Trans } from "react-i18next";
import I18nSelect from "../../components/@common/I18nSelect";

function PrivacyPolicy() {
  const { translator } = useLanguageTranslator();
  return (
    <>
      <Box pb={3}>
        <AppBar>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexGrow={1}
          >
            <PageTitle title={translator(`Privacy Policy`)} subtitle="" />
            {/* <SearchBar placeholder="Search tree and keyword" /> */}
            <I18nSelect
              options={[
                { label: translator("English"), value: "en" },
                { label: translator("French"), value: "fr" },
                { label: translator("Portuguese"), value: "pt" },
              ]}
            />
          </Stack>
        </AppBar>

        <Box
          px={10}
          py={5}
          borderRadius={"10px"}
          sx={{ backgroundColor: "white" }}
        >
          <Typography paragraph sx={{ fontWeight: "700" }}>
            {translator(`Last update`)} : {translator(`Last update date`)}
          </Typography>
          <Typography paragraph sx={{ fontWeight: "700" }}>
            <span style={{ fontWeight: "700" }}>
              {translator(`Publisher`)} :
            </span>{" "}
            NIYEL
          </Typography>
          <Typography paragraph sx={{ fontWeight: "700" }}>
            <span style={{ fontWeight: "700" }}>{translator(`Contact`)} :</span>{" "}
            <Link
              href="mailto:info@niyel.net"
              underline="hover"
              style={{
                fontWeight: "500",
                textDecoration: "underline",
                color: "blue",
              }}
            >
              info@niyel.net
            </Link>
          </Typography>

          <Typography variant="h4" gutterBottom>
            1. {translator(`Preamble`)}
          </Typography>

          <Typography paragraph pl={4}>
            <Trans
              i18nKey="sub.description"
              components={{ strong: <strong /> }}
            />
          </Typography>
          <Typography paragraph pl={4}>
            {translator(`sub.explain`)}
          </Typography>
          <Typography paragraph pl={4}>
            {translator(`personal.data`)}
          </Typography>
          <Typography paragraph pl={4}>
            {translator(`sub.purposes`)}
          </Typography>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            2. {translator(`Definitions`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.cookies"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.personal"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.niyel"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.subject"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.controller"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.processor"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.processing"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="definitions.users"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            3. {translator(`Data Controller`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="controller.identity"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="controller.address"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="controller.contact"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="controller.telephone"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            4. {translator(`Data collected`)}
          </Typography>
          <Typography paragraph>
            {translator(`datacollected.description`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="datacollected.identification"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="datacollected.connection"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="datacollected.device"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="datacollected.public"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <Typography paragraph>
              {translator(`datacollected.sensitive`)}
            </Typography>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            5. {translator(`Cookies and Trackers`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<>{translator(`cookies.navigation`)}</>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={<>{translator(`cookies.desactivate`)}</>}
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            6. {translator(`Purposes of processing`)}
          </Typography>
          <Typography paragraph>
            {translator(`processing.description`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="processing.creation"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="processing.access"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <strong>
                      {translator(
                        `Analyze and monitor the evolution of public policies.`
                      )}
                    </strong>
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <strong>
                      {translator(
                        `Improve the tool and personalize your experience.`
                      )}
                    </strong>
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <strong>
                      {translator(`Comply with legal obligations.`)}
                    </strong>
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            7. {translator(`Legal basis.`)}
          </Typography>
          <Typography paragraph>
            {translator(`Processing is based on:`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="processing.consent"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="processing.legal"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            8. {translator(`Data sharing`)}
          </Typography>
          <Typography paragraph>
            {translator(`Your data may be shared with:`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="sharing.subcontractors"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="sharing.authorities"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            9. {translator(`International transfers:`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<>{translator(`transfers.event`)}</>} />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<>{translator(`transfers.ensure`)}</>} />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            10. {translator(`Data security`)}
          </Typography>
          <Typography paragraph>
            {translator(`security.description`)}
          </Typography>
          <Typography paragraph>{translator(`security.subdesc`)}</Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `Restriction of database access to authorized users.`
                    )}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `Definition of roles and permissions to limit access to resources as required.`
                    )}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `Use of a robust hash algorithm to store user passwords.`
                    )}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(`Protection against common malicious attacks.`)}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `Use of SSL certificates to guarantee secure communication between browsers and the web server.`
                    )}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `A firewall to filter traffic and block malicious requests.`
                    )}
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    {translator(
                      `Secure server configuration to limit access to files and other resources.`
                    )}
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            11. {translator(`Data retention`)}
          </Typography>
          <Typography paragraph>
            {translator(`retention.description`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="retention.identification"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="retention.connection"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="retention.public"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            12. {translator(`Users' rights`)}
          </Typography>
          <Typography paragraph>{translator(`rights.desc`)}</Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="rights.access"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="rights.rectification"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="rights.deletion"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <Trans
                      i18nKey="rights.opposition"
                      components={{ strong: <strong /> }}
                    />
                  </>
                }
              />
            </ListItem>
          </List>
          <Typography paragraph>
            <Trans
              i18nKey="rights.footerone"
              components={{ strong: <strong /> }}
            />
          </Typography>
          <Typography paragraph>{translator(`rights.footertwo`)}</Typography>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            13. {translator(`Modification of the Policy`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={<>{translator(`modification.description`)}</>}
              />
            </ListItem>
          </List>
          <Divider sx={{ my: 4 }} />
          <Typography variant="h4" gutterBottom>
            14. {translator(`Disputes and recourse`)}
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 7 }} disablePadding>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText primary={<>{translator(`disputes.desc`)}</>} />
            </ListItem>
          </List>

          <Divider sx={{ margin: "20px 0px" }} />

          <Typography
            sx={{
              fontStyle: "italic",
              fontWeight: 400,
              marginLeft: "32px",
            }}
          >
            {translator(`We invite you to consult this page regularly for updates.`)}
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export { PrivacyPolicy };
